import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/components/api-call.ngfactory.ts